var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.269231 11.0833C0.197436 11.0833 0.134616 11.0565 0.0807694 11.0029C0.0269232 10.9493 0 10.8867 0 10.8152V0.500537C0 0.357527 0.0478631 0.238351 0.14359 0.143011C0.239316 0.0476701 0.358974 0 0.502564 0H4.61282C4.73248 0 4.84017 0.0357528 4.9359 0.107258C5.03162 0.178764 5.09145 0.274104 5.11538 0.39328L5.33077 1.48374H8.83077C8.97436 1.48374 9.09402 1.53141 9.18974 1.62675C9.28547 1.72209 9.33333 1.8353 9.33333 1.9664V6.47124C9.33333 6.60233 9.28547 6.71555 9.18974 6.81089C9.09402 6.90623 8.97436 6.9539 8.83077 6.9539H6.21026C6.0906 6.9539 5.9859 6.91814 5.89615 6.84664C5.80641 6.77513 5.74957 6.67979 5.72564 6.56062L5.49231 5.47016H0.55641V10.8152C0.55641 10.8867 0.529487 10.9493 0.475641 11.0029C0.421795 11.0565 0.352991 11.0833 0.269231 11.0833Z",
    fill: "url(#paint0_linear_6892_5886)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6892_5886",
    x1: 8.24113,
    y1: 0.205246,
    x2: -1.4211,
    y2: 3.86334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a3dd8eeb68504514e72b3ad68c970acc.svg";
export { ForwardRef as ReactComponent };